import axios from 'axios';
import {get, isString} from 'lodash';

const baseURL = `${process.env.GATSBY_STRAPI_FORM_URL}`;
const token = process.env.GATSBY_STRAPI_FORM_TOKEN;

const authInstance = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: `Bearer ${token}`,
    // "Content-Type": "multipart/form-data"
  },
});


export const postFileData = async (data) => {

  const res = await authInstance.post('upload', data)
  .then((res) => {
    // Success
    if (res.status === 200 || res.status === 201) {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      return { success: false, message: 'Network error' }
    }
  })
  return res;

}

export const postFormData = async (data) => {
  const res = await authInstance.post('/stb-forms/forms', data)
  .then((res) => {
    // Success
    if (res.status === 200 || res.status === 201) {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      return { success: false, message: 'Network error' }
    }
  })
  
  try {
    let formDatavalues = {};
    for (const pair of data.entries()) {
      if (isString(pair[1])) {
        formDatavalues = JSON.parse(pair[1]);
      }
    }
    let email = formDatavalues.email || 'email';
    if (!res || get(res, 'success') == false) {
      let errorMessage = get(res, 'message', "Strapi responded to fail");
      fetch('/api/log-form-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ formdata: formDatavalues, error: errorMessage, email }),
      }).catch(() => {});
    }
  } catch(e) {
    console.log(91, e);
  }

return res;

}